import GetEnumData from "./helpers";

let enumsGameName = {
    "same-color" : { Label: "Same Color", Color: "sameColor" },
    "good-color-name" : { Label: "Good Color Name", Color: "goodColorName" },
    "f1-start-timer" : { Label: "F1 Start Timer", Color: "f1StartTimer" },
    "lights-wall" : { Label: "Lights Wall", Color: "lightsWall" },
}

let GameName = {
	url: () => {
		let urls = [];
		Object.entries(enumsGameName).map(game => {
			urls = [
				...urls,
				game[0]
			];
		})
		return urls;
	},
	label: (labelGameName) => {
		return GetEnumData(enumsGameName, labelGameName).Label;
	},
	color: (labelGameName) => {
		return GetEnumData(enumsGameName, labelGameName).Color;
	},
};

export default GameName;